<template>
    <svg
      :width="width"
      :height="10 + (displayLevel - 1) * gap"
      :viewBox="`0 0 18 ${10 + (displayLevel - 1) * gap}`"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :class="color"
    >
      <g v-for="i in displayLevel" :key="i" :transform="`translate(0, ${(displayLevel - i) * gap})`">
        <!-- Fill to mask overlaps -->
         <path
            d="M9 1L17 5L9 9L1 5L9 1Z"
            :fill="bgColor"
            stroke="none"
          />
          <!-- Outline on top -->
          <path
            d="M9 1L17 5L9 9L1 5L9 1Z"
            stroke="currentColor"
            :stroke-width="strokeWidth"
            fill="none"
            stroke-linejoin="round"
          />
      </g>
    </svg>
  </template>
  
  <script>
  export default {
    name: 'org-layer-icon',
    props: {
      level: { type: Number, default: 1 },         // 1~N단
      width: { type: [String, Number], default: 18 },
      color: { type: String, default: 'text-[#4D5159]' },
      strokeWidth: { type: [String, Number], default: 1.5 },
      gap: { type: Number, default: 4 },           // 단 사이 간격(px)
      bgColor: { type: String, default: '#FFFFFF' }, // 겹침부 숨기기 위한 배경색
    },
    data() {
      return {
        maxLevel: 3,
      };
    },
    computed: {
      displayLevel() {
        return Math.min(this.level, this.maxLevel);
      },
    },
  };
  </script>